import { createSelector } from 'reselect'
import { getExperiencesPassportCheckoutKey } from 'checkout/lib/experiencesPassport'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

const isExperiencesPassportReady = createSelector(
  (state: App.State) => state.checkout.cart,
  (state: App.State) => state.checkout.experiencesPassportReconciliation,
  (state: App.State) => state.checkout.accommodationSessions,
  (cart, reconciliation, sessions) => {
    if (findPostPurchaseCheckout(cart.mode)) return true

    const key = getExperiencesPassportCheckoutKey(cart, sessions)
    return !key || (reconciliation?.key === key && reconciliation.status !== 'loading')
  },
)

export default isExperiencesPassportReady
